import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
import { LocalStorageService } from "../services/LocalStorage";
import AxiosService from "../services/APIService";

const ProtectedRoute = ({ layout: Layout, component: Component, isUserLogin, ...rest }) => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get('token');
    
    if (urlToken) {
        LocalStorageService.setItem("userToken", urlToken);
        const apiService = new AxiosService();
        apiService.get('/auth/me')
            .then(response => {
                if (response) {
                    LocalStorageService.setItem("user", response.user);
                }
            })
            .catch(error => {
                console.error("Error fetching user data:", error);
            });
        window.history.replaceState({}, document.title, window.location.pathname);
    }

    const token = LocalStorageService.getItem('userToken');
    const userData = LocalStorageService.getItem("user");

    const isAuthenticated = () => {
        return (isUserLogin || token);
    };

    if (!isAuthenticated()) {
        return <Navigate to="/" />;
    }

    return (
        <Layout>
            <Component {...rest} />
        </Layout>
    );
};

const mapStateToProps = ({ login }) => {
    const { user, isUserLogin } = login;
    return { user, isUserLogin }
};

export default connect(mapStateToProps, {})(ProtectedRoute);